import { render } from "./DevicesTab.vue?vue&type=template&id=22400ee2&scoped=true"
import script from "./DevicesTab.vue?vue&type=script&lang=js"
export * from "./DevicesTab.vue?vue&type=script&lang=js"

import "./DevicesTab.vue?vue&type=style&index=0&id=22400ee2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22400ee2"]])

export default __exports__